import { render } from "./car2.vue?vue&type=template&id=36d91fe7&scoped=true"
import script from "./car2.vue?vue&type=script&lang=js"
export * from "./car2.vue?vue&type=script&lang=js"

import "./car2.vue?vue&type=style&index=0&id=36d91fe7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d91fe7"]])

export default __exports__